import { callSelectors, callActions } from '@lifesize/nucleus';
import { Observer } from '@lifesize/web-clients-core';

const initialData = {
  endCallOnUnload: false,
};

// eslint-disable-next-line no-restricted-globals
const terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';

const onUnload = () => {
  window.lifesize.store.dispatch(callActions.end());
};

const handler = (oldData, newData) => {
  if (!oldData.callFullyConnected && newData.callFullyConnected) {
    window.addEventListener(terminationEvent, onUnload, { capture: true });
  }

  if (!newData.callFullyConnected && oldData.callFullyConnected) {
    window.removeEventListener(terminationEvent, onUnload, { capture: true });
  }
};

export const handlerMethods = [callSelectors.activeCallSelector, initialData, handler];
export default Observer.createObserver(...handlerMethods);
